<template>
  <div class="sale-box__segment-head">
    <div class="sale-box__ratings">
      <div class="sale-box__ratings-wrapper">
        <ratings
          :rating="productDetails.product.reviewsAverage"
          href="#reviewForm"
          type="disabled"
        />
        <template
          v-if="productDetails.product.reviewsRecommendationPercentage >= minRecoPercentage && productDetails.product.reviewsCount >= 5"
        >
          <span class="sale-box__ratings-count">
            {{ $t('ads.main.head.reviews.rating.count', [productDetails.product.reviewsCount]) }}
          </span>
          <a
            href="#reviewForm"
            class="sale-box__ratings-percentage"
            @click.prevent="$emit('rateNowClicked')"
          >
            {{ $t('ads.main.head.reviews.rating.percentage', [productDetails.product.reviewsRecommendationPercentage]) }}
          </a>
        </template>
        <template v-else>
          <span
            v-if="productDetails.product.reviewsCount > 0"
            class="sale-box__ratings-count"
          >
            {{ $t('ads.main.head.reviews.rating.count', [productDetails.product.reviewsCount]) }}
          </span>
          <a
            href="#reviewForm"
            class="sale-box__ratings-link"
            @click.prevent="$emit('rateNowClicked')"
          >
            {{ $t(productHasCurrentUsersReview ? 'ads.main.head.reviews.rating.rated' : 'ads.main.head.reviews.rating.rate_now') }}
          </a>
        </template>
        <span
          class="sale-box__sale-unit"
          v-html="productDetails.product.offerHtml"
        />
      </div>
    </div>
    <h1 class="sale-box__headline">
      <span
        class="sale-box__vintage"
        v-if="productDetails.product.vintage"
        v-html="productDetails.product.vintage"
      />
      <div class="sale-box__product-name">
        {{ productDetails.product.description1 }}
      </div>
      <span
        class="sale-box__short-description"
        v-if="productDetails.product.description2"
        v-html="productDetails.product.description2"
      />
      <span
        class="sale-box__short-description"
        v-if="productDetails.product.description3"
        v-html="productDetails.product.description3"
      />
    </h1>
    <button
      v-if="!productDetails.product.zeroPriceItem && !productDetails.product.recurringOrderFollowUpPacket"
      class="sale-box__button-wishlist"
      :class="{
        'sale-box__button-wishlist--filled': productDetails.product.inWishlist,
        'sale-box__button-wishlist--loading': state === 'loadingWishlist',
        'sale-box__button-wishlist--top-right': !productDetails.product.vintage
      }"
      type="button"
      @click.prevent="$emit('wishlistClicked')"
    />
  </div>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator' ;
  import Ratings from '../../../bps/components/ratings/ratings.vue'
  import type ProductDetails from '../../../bps/types/ProductDetails';

  @Options({
    name: 'sale-box-segment-head',
    components: {Ratings},
  })
  export default class SaleBoxSegmentHead extends Vue {
    @Prop()
    minRecoPercentage: number;
    @Prop()
    productDetails: ProductDetails;
    @Prop()
    state: string;
    @Prop()
    toggleWishlist: Function;
    @Prop()
    productHasCurrentUsersReview: boolean;
  }
</script>
